import React, { useState, useEffect } from 'react';
import { Label, InputGroup, InputGroupText, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiFilterOutline } from '@mdi/js';

import _ from 'lodash';

export const GroupsFilter = ({ groups, onChange}) => {
    const [ filters, setFilters ] = useState({ day: -1, teacher: null, search: '' });
    const { t } = useTranslation();

    useEffect(() => {
        onChange(filters);
    }, [filters]);

    if (!groups)
        return null;

    const days     = _.uniqBy(_.flatten(groups.map(g => g.classrooms?.map(c => ({ id: c.week_day, text: c.getSchedulingDayText() })))), 'id');
    const teachers = _.uniqBy(_.flatten(groups.map(g => g.classrooms?.map(c => ({ id: c.teacher?.id, text: c.teacher?.firstname })))), 'id');
    return (
        <div className="GroupsFilter">
            <Label tag="h4">{ t('groups.filter') }</Label>
            <Label tag="em">{ t('groups.filter_desc') }</Label>
            <InputGroup className="mt-4">
                <InputGroupText>
                    <Icon path={mdiFilterOutline} size={1} />
                </InputGroupText>
                <Input id="day" name="day" type="select" className="form-control" onChange={ e => setFilters({ ...filters, day: parseInt(e.target.value, 10)}) }>
                    <option value={ -1 }>{ t('groups.choose_a_day') }</option>
                    { days.map(day => (
                        <option key={ day.id } value={ day.id }>
                            { day.text }
                        </option>
                    ))}
                </Input>
                <Input id="teacher" name="teacher" type="select" className="form-control" onChange={ e => setFilters({ ...filters, teacher: e.target.value}) }>
                    <option value={ '' }>{ t('groups.choose_a_teacher') }</option>
                    { teachers.map(teacher => (
                        <option key={ teacher.id } value={ teacher.id }>
                            { teacher.text }
                        </option>
                    ))}
                </Input>
                <Input id="search" name="search" type="text" className="form-control" onChange={ e => setFilters({ ...filters, search: e.target.value}) } placeholder={ t('groups.search') } />
            </InputGroup>
        </div>
    );
}
